import { serverListenToBreakoutGroup } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { CrossRemoveIcon, SoundLevelOnIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCurrentClassUser } from "store/selectors";
import { selectCurrentListenedBreakoutGroupId } from "store/selectors/breakouts";
import { toastLocalizedOperationCatcher } from "utils/alerts";

function BreakoutListeningToggleButton({
  breakoutGroupId,
  showListeningButton = true,
}: {
  breakoutGroupId: string;
  showListeningButton?: boolean;
}) {
  const currentClassUserId = useAppSelector(selectCurrentClassUser)?.id;
  const currentListenedBreakoutGroupId = useAppSelector(selectCurrentListenedBreakoutGroupId);
  const isListeningToThisBreakout = currentListenedBreakoutGroupId === breakoutGroupId;
  const onListenToBreakoutGroup = async () => {
    if (!currentClassUserId) return;
    await serverListenToBreakoutGroup(currentClassUserId, breakoutGroupId).catch(
      toastLocalizedOperationCatcher("failed_to_listen_to_breakout_group"),
    );
  };

  const onStopListeningToBreakoutGroup = async () => {
    if (!currentClassUserId) return;
    await serverListenToBreakoutGroup(currentClassUserId, null).catch(
      toastLocalizedOperationCatcher("failed_to_stop_listening_to_breakout_group"),
    );
  };

  return (
    <SquareButton
      eventName={`Breakout Room -  ${currentListenedBreakoutGroupId ? "Stop Listening" : "Listen"}`}
      kind="tertiary"
      size="xs"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (currentListenedBreakoutGroupId === breakoutGroupId) {
          onStopListeningToBreakoutGroup();
        } else {
          onListenToBreakoutGroup();
        }
      }}
    >
      {isListeningToThisBreakout ? (
        <IconText
          iconStart={<CrossRemoveIcon size="xs" />}
          text={t("breakouts_control_panel.stop_listening")}
        />
      ) : showListeningButton ? (
        <IconText
          iconStart={<SoundLevelOnIcon size="xs" />}
          text={t("breakouts_control_panel.listen")}
        />
      ) : null}
    </SquareButton>
  );
}

export { BreakoutListeningToggleButton };
